import { lazy } from "react";
import { useSearchParams } from "react-router-dom";
// import Docs from "./clinicalvisuals-docs.tsx";

// Features & Components
const DefaultLandingPage = lazy(() => import("../features/components/landing-page-group.tsx"));
const EntVideoPage = lazy(() => import("../components/layouts/EntVideoPage.tsx"));
const EntDemoPage = lazy(() => import("../components/layouts/EntDemoPage.tsx"));
const ContactThemeGenerate = lazy(() => import("../features/components/color_theme.tsx"));
const SpineStaticLegal = lazy(() => import("../features/utahlegal/utahlegal.tsx"));
const Login = lazy(() => import("../userAuth/Login/index.tsx"));
const ShareAnimation = lazy(() => import("../users/shareAnimation/index.tsx"));
const UserProfile = lazy(() => import("../users/settings/profileSetings/userProfile.tsx"));
const Rejoni = lazy(() => import("../features/rejoni/index.tsx"));
const RejoniPresentation = lazy(() => import("../features/rejoni-presentation/rejoni.tsx"));
const DefaultMessageSetting = lazy(() => import("../users/settings/shareanimationSetings/defaultMessageSetting.tsx"));
const ManagerUser = lazy(() => import("../users/manageAccounts/manageUsers.tsx"));
const Logout = lazy(() => import("../userAuth/Login/logout.tsx"));
const LoopSetting = lazy(() => import("../users/animationloop/loopsetting.tsx"));
const HomePage = lazy(() => import("../users/dashboard/home/homePage.tsx"));
const EmailTemplate = lazy(() => import("../users/emailTemplate/email_template.tsx"));
const ShortURLAnimationViewnew = lazy(() => import("../features/animationView/animationViewnew.tsx"));
const LigerFinal = lazy(() => import("../features/liger/ligerFinalDelivery.tsx"));
const ManageLocation = lazy(() => import("../users/manageAccounts/manageLocations/manageLocation.tsx"));
const UsageReport = lazy(() => import("../users/reports/usageReports.tsx"));
const ManageLocationsClass = lazy(() => import("../users/manageAccounts/manageLocationclass/managelocationsclass.tsx"));
const ManageFavourites = lazy(() => import("../users/manageAccounts/manageFavourites/manageFavourites.tsx"));
const SharedAnimationReport = lazy(() => import("../users/reports/sharedAnimationReport.tsx"));
const Favorites = lazy(() => import("../users/favorites/favorites.tsx"));
const PreloginAboutUs = lazy(() => import("../PreloginComponent/Layout/AboutUs.tsx"));
const PreloginContact = lazy(() => import("../PreloginComponent/Layout/ContactUs.tsx"));
const Signup = lazy(() => import("../PreloginComponent/Layout/Signup.tsx"));
const PreloginServices = lazy(() => import("../PreloginComponent/Layout/Services.tsx"));
const Success = lazy(() => import("../users/stripe/stripeSuccess.tsx"));
const Failure = lazy(() => import("../users/stripe/failureStripe.tsx"));
const WomensHealthDemo = lazy(() => import("../components/layouts/womensHealthDemo.tsx"));
const BusinessCards = lazy(() => import("../PreloginComponent/OurVisionaries/BusinessCards.tsx"));
const ManageCategories = lazy(() => import("../users/settings/manageCategory/manageCategories.tsx"));
const ManageSubscription = lazy(() => import("../users/manageAccounts/manageSubscriptions/manageSubscription.tsx"));
const AnimationDemoPage = lazy(() => import("../components/layouts/Animationdemos.tsx"));
const CustomAnimations = lazy(() => import("../components/layouts/customAnimatons.tsx"));
const MyVideos = lazy(() => import("../users/myVideos/myVideos.tsx"));
const PreloginHome2 = lazy(() => import("../PreloginComponent/Layout/PreloginHome/PreloginHome.tsx"));
const CustomDemos = lazy(() => import("../components/layouts/customDemos.tsx"));
const ResetPassword = lazy(() => import("../userAuth/Resetpassword/resetPassword.tsx"));
const Custom404 = lazy(() => import("../features/components/custom-404.tsx"));
const Crani = lazy(() => import("../components/layouts/HomePage.tsx"));
const Sealonix = lazy(() => import("../features/spine/spine-static.tsx"));
const GutLab = lazy(() => import("../features/gutlab/gutlab.tsx"));
const Liger = lazy(() => import("../features/liger/liger.tsx"));
const CosmeticSurgery = lazy(() => import("../features/cosmeticSurgery/cosmeticSurgery.tsx"));
const PlayLoop = lazy(() => import("../users/animationloop/loopvideo.tsx"));
const PresentationSlider = lazy(() => import("../PreloginComponent/presentationSlide.tsx"));
const PresentationVideoSlider = lazy(() => import("../PreloginComponent/slides/PresentationVideoSlider.tsx"));
const PresentationVideoLoop = lazy(() => import("../PreloginComponent/slides/PresentationVideoLoop.tsx"));
const RandomComponentWrapper = lazy(() => import("./randomFreeTrial.tsx"));
const UserGuideAnimationDemoPage = lazy(() => import("../components/layouts/UserGuideAnimationDemos.tsx"));
const PrivacyPolicy = lazy(() => import("../PreloginComponent/PrivacyPolicy.tsx"));
const AnimationShortDemoPage = lazy(() => import("../components/layouts/AnimationShortDemos.tsx"));
const TotalUsersReport = lazy(() => import("../users/totalUsersReport/index.tsx"));
const UserGuide = lazy(() => import("../users/userGuide/index.tsx"));
const AutoFreeTrialSignup = lazy(() => import("../PreloginComponent/AutoFreeTrialSignup.tsx"));
const Mnhi = lazy(() => import("../features/Mnhi/mnhi.tsx"));
const Laborie = lazy(() => import("../features/Laborie/laborie.tsx"));
const celox = lazy(() => import("../features/Celox PPH/celox-pph.tsx"));
const AssistCupNew = lazy(() => import("../features/assistCup/assistCup.tsx"));
const Vyne = lazy(() => import("../features/vyne/vyne.tsx"));
const AtilaBioSystems = lazy(() => import("../features/atila-biosystems/atila-biosystems.tsx"));
const Biocer = lazy(() => import("../features/biocer/biocer.tsx"));
const Troge = lazy(() => import("../features/troge/troge.tsx"));
const EmosTechnology = lazy(() => import("../features/emos-technology/emosTechnology.tsx"));
const Invotec = lazy(() => import("../features/invotec/invotec.tsx"));
const Bytec = lazy(() => import("../features/bytec/bytec.tsx"));
const KAPMedica = lazy(() => import("../features/kap-medica/kap-medica.tsx"));
const NOXBOXLTS = lazy(() => import("../features/noxbox-lts/noxbox-lts.tsx"));
const TSIIncorporated = lazy(() => import("../features/TSIIncorporated/tsi-incorporated.tsx"));
const Soniquence = lazy(() => import("../features/soniquence/soniqunece.tsx"));
const Gnomon = lazy(() => import("../features/gnomon/gnomon.tsx"));
const GeneratedLinkShortUrl = lazy(() => import("../PreloginComponent/ShortUrlUpdate.tsx"));
const kapMedica = lazy(() => import("../features/medical/medical.tsx"));
const EmosTechDemo = lazy(() => import("../features/medical/emos-technology-demo.tsx"));
const BytecDemo = lazy(() => import("../features/medical/bytec-healthcare.tsx"));
const BiocerDemo = lazy(() => import("../features/medical/biocer.tsx"));
const InvotecDemo = lazy(() => import("../features/medical/invotec-demo.tsx"));
const SleepnetDemo = lazy(() => import("../features/medical/sleepnet-demo.tsx"));
const Sleepnet = lazy(() => import("../features/sleepnet/sleepnet.tsx"));
const GynHealthDemo = lazy(() => import("../features/medical/gyn-health-demo.tsx"));
const NoxBoxDemo = lazy(() => import("../features/medical/noxbox-demo.tsx"));
const TSIIncorporatedDemo = lazy(() => import("../features/medical/tsi-incorporated-demo.tsx"));
const HeyPatientDemo = lazy(() => import("../features/medical/hey-patient-demo.tsx"));
const VyneDemo = lazy(() => import("../features/medical/vyne-demo.tsx"));
const IntegraDemo = lazy(() => import("../features/medical/integra-demo.tsx"));
const UzumcuDemo = lazy(() => import("../features/medical/uzumcu-demo.tsx"));
const Histologics = lazy(() => import("../features/medical/histologics.tsx"));
const BusinessDynamicPage = lazy(() => import("../features/business/BusinessDynamicPage.tsx"));
const ProjectProposalStatic = lazy(() => import("../features/project-proposal/project-proposal.tsx"));
const PFMMedicalDemo = lazy(() => import("../features/medical/pfm-medical-demo.tsx"));
const CustomAnimRedirect = lazy(() => import("../features/components/CustomAnimRedirect.tsx"));
const Docs = lazy(() => import("./clinicalvisuals-docs.tsx"));
const isClinicalDomain = window.location.host.includes("localhost:5173");
console.log("isClinicalDomain", isClinicalDomain)
const checkHost = window.location.hostname
// console.log("checkhost", checkHost)

const ProtectedResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  return token ? <ResetPassword /> : <Custom404 />;
};

export const publicRoutes = [
  { path: "/", component: PreloginHome2 },
  { path: "/old-landing", component: DefaultLandingPage },
  { path: "/shareDesign", component: ShortURLAnimationViewnew },
  { path: "/custom-animations", component: CustomAnimations },
  { path: "/presentation", component: PresentationSlider },
  { path: "/presentation-videos", component: PresentationVideoSlider },
  { path: "/presentation-loop", component: PresentationVideoLoop },
  { path: "/ent", component: EntVideoPage },
  { path: "/demo", component: AnimationDemoPage },
  { path: "/short-demo", component: AnimationShortDemoPage },
  { path: "/user-guide/demo", component: UserGuideAnimationDemoPage },
  { path: "/demos", component: CustomDemos },
  { path: "/entdemo", component: EntDemoPage },
  // { path: "/obgyndemo", component: EntDemoPage },
  { path: "/whdemo", component: WomensHealthDemo },
  { path: "/utahlegalvideo", component: SpineStaticLegal },
  { path: "/rejoni", component: Rejoni },
  { path: "/rejoni-presentation", component: RejoniPresentation },
  { path: "/contact-us-theme", component: ContactThemeGenerate },
  { path: "/signup", component: Signup },
  // { path: "/login", component: checkHost === "localhost" || checkHost === "clinicalvisuals.com" ? PreloginHome2 : Login },
  {path : "/login", component: Login},
  { path: "/emailtemplate", component: EmailTemplate },
  { path: "/finalDelivery/liger", component: LigerFinal },
  { path: "/contactus", component: PreloginContact },
  { path: "/aboutus", component: PreloginAboutUs },
  { path: "/services", component: PreloginServices },
  { path: "/freetrial", component: checkHost === "localhost" || checkHost === "clinicalvisuals.com" ? PreloginHome2 : RandomComponentWrapper },
  { path: "/payment-success", component: Success },
  { path: "/payment-cancel", component: Failure },
  { path: "/business-cards/:user", component: BusinessCards },
  { path: "/resetpassword", component: ProtectedResetPassword },
  { path: "/craniseal", component: Crani },
  { path: "ca/:custom_animation", component: Sealonix },
  { path: "/sealonix", component: Sealonix },
  { path: "/gutlab", component: GutLab },
  { path: "/liger", component: Liger },
  { path: "/vyne", component: Vyne },
  { path: "/atila-biosystems", component: AtilaBioSystems },
  { path: "/cosmetic-surgery", component: CosmeticSurgery },
  { path: "/mnhi", component: Mnhi },
  { path: "/laborie", component: Laborie },
  { path: "/assistcup", component: AssistCupNew },
  { path: "/celox-pph", component: celox },
  { path: "/troge", component: Troge },
  { path: "/biocer", component: Biocer },
  { path: "/emos-technology", component: EmosTechnology },
  { path: "/invotec", component: Invotec },
  { path: "/bytec", component: Bytec },
  { path: "/gnomon", component: Gnomon },
  { path: "/kap-medica", component: KAPMedica },
  { path: "/noxbox-lts", component: NOXBOXLTS },
  { path: "/tsi-incorporated", component: TSIIncorporated },
  { path: "/soniquence", component: Soniquence },
  { path: "/privacy-policy", component: PrivacyPolicy },
  { path: "/terms-of-service", component: PrivacyPolicy },
  { path: "/auto-sign-up", component: AutoFreeTrialSignup },
  { path: "/gl/:shortCode", component: GeneratedLinkShortUrl },
  { path: "/kap-demo", component: kapMedica },
  { path: "/bytec-demo", component: BytecDemo },
  { path: "/emos-demo", component: EmosTechDemo },
  { path: "/biocer-demo", component: BiocerDemo },
  { path: "/invotec-demo", component: InvotecDemo },
  { path: "/sleepnet-demo", component: SleepnetDemo },
  { path: "/gynhealth-demo", component: GynHealthDemo },
  { path: "/noxbox-demo", component: NoxBoxDemo },
  // { path: "/soniquence-demo", component: SoniquenceDemo },
  { path: "/heypatient-demo", component: HeyPatientDemo },
  { path: "/tsi-incorporated-demo", component: TSIIncorporatedDemo },
  { path: "/vyne-demo", component: VyneDemo },
  { path: "/integra-demo", component: IntegraDemo },
  { path: "/uzumcu-demo", component: UzumcuDemo },
  { path: "/histologics-demo", component: Histologics },
  { path: "/pfm-medical-demo", component: PFMMedicalDemo },
  { path: "/sleepnet", component: Sleepnet },
  { path: "/project-proposal/:slug", component: ProjectProposalStatic },
  { path: "/business/:businessName/:purpose", component: BusinessDynamicPage },
  { path: "/docs", component: Docs },
  { path: "*", component: CustomAnimRedirect },
];

export const privateRoutes = [
  { name: "Home", path: "/home", component: HomePage },
  {
    name: "Share Animation",
    path: "/share-animation",
    component: ShareAnimation,
  },
  { name: "Favorites", path: "/favorites", component: Favorites },
  { name: "My Videos", path: "/my-videos", component: MyVideos },
  { name: "Profile Setting", path: "/profile-setting", component: UserProfile },
  {
    name: "Email Setting",
    path: "/email-setting",
    component: DefaultMessageSetting,
  },
  {
    name: "Manage Favorites",
    path: "/manage-favorites",
    component: ManageFavourites,
  },
  {
    name: "Manage Categories",
    path: "/manage-categories",
    component: ManageCategories,
  },
  {
    name: "Manage Locations",
    path: "/settings/manage-locations",
    component: ManageLocation,
  },
  {
    name: "Manage Locations Class",
    path: "/settings/manage-locations-class",
    component: ManageLocationsClass,
  },
  {
    name: "Manage Users",
    path: "/settings/manage-users",
    component: ManagerUser,
  },
  {
    name: "Manage Subscriptions",
    path: "/settings/manage-subscriptions",
    component: ManageSubscription,
  },
  {
    name: "Loop Setting",
    path: "/animationloop/loop-setting",
    component: LoopSetting,
  },
  { name: "Usage Reports", path: "/usageReports", component: UsageReport },
  {
    name: "Shared Animation Report",
    path: "/shared-animation-report",
    component: SharedAnimationReport,
  },
  {
    name: "Total Users Report",
    path: "/total-users-report",
    component: TotalUsersReport
  },
  {
    name: "User Guide",
    path: "/user-guide",
    component: UserGuide,
  },
  { name: "logout", path: "/logout", component: Logout },
  { name: "loopVideo", path: "/loopvideo", component: PlayLoop },
];
